import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'SSO|Egress';

export type SSOEgressTestwise =
	| 'CPSSOEgressTestwiseButton'
	| 'CPSSOEgressTestwiseTabTitle'
	| 'CPSSOEgressTestwisePageTitle'
	| 'CPSSOEgressTestwisePageDescription';

export const ssoTestwiseEgressLocs: LocDefs<SSOEgressTestwise> = {
	CPSSOEgressTestwiseButton: {
		defaultValue: 'SSO to Testwise',
		description: 'Button to SSO to Testwise.',
		displayPath: `${dpRoot}|Testwise`,
		displayType: 'Button',
		htmlAllowed: false,
		feature: HubFeature.CandidateAccessIntegrationEgressTestWise,
		portal: 'CP',
	},
	CPSSOEgressTestwiseTabTitle: {
		defaultValue: 'Schedule an Exam',
		description: 'Tab title of Testwise SSO page.',
		displayPath: `${dpRoot}|Tab Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccessIntegrationEgressTestWise,
		portal: 'CP',
		htmlAllowed: false,
		legacyName: 'CandidateAccess.Integration.Egress.Testwise/Scheduling.Exam.Title.TabTitle',
	},
	CPSSOEgressTestwisePageTitle: {
		defaultValue: 'Testwise SSO',
		description: 'Title of Testwise SSO page.',
		displayPath: `${dpRoot}|Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccessIntegrationEgressTestWise,
		portal: 'CP',
		htmlAllowed: false,
		legacyName: 'CandidateAccess.Integration.Egress.Testwise/Scheduling.Exam.Title.PageTitle',
	},
	CPSSOEgressTestwisePageDescription: {
		defaultValue: '',
		description: 'Page description for the Testwise SSO page.',
		displayPath: `${dpRoot}|Page Description`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessIntegrationEgressTestWise,
		portal: 'CP',
		htmlAllowed: true,
		legacyName:
			'CandidateAccess.Integration.Egress.Testwise/Scheduling.Exam.Content.PageDescription',
	},
};
export const LOC_KEYS = MapLocKeys<SSOEgressTestwise>(ssoTestwiseEgressLocs);
